// dependencies
import React from "react";
import { useFormik, FormikProvider } from "formik";
// constants
import { loginInitialValues } from "@constants/initialValues";
import { LoginValidationSchema } from "@constants/validationSchema";
import { ILogin } from "@constants/interfaces";
import Input from "@/components/forms/Input";
import Password from "@/components/forms/Password";
import { Link } from "react-router-dom";
import { Button } from "primereact/button";
import { toast } from "react-toastify";
import useSettingsStore from "@/theme/settings";
import AuthLayout from "@/layouts/AuthLayout";

export default function Login() {
  const [loading, setLoading] = React.useState(false);
  const setSession = useSettingsStore((state) => state.setSession);

  const formik = useFormik({
    initialValues: loginInitialValues,
    validationSchema: LoginValidationSchema,
    onSubmit: (values: ILogin) => {
      /*
       *
       * //TODO: Replace with login logic
       *
       */
      console.log("login");
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        toast.success("Login successful");
        setSession("active");
      }, 2000);
    },
  });

  const { values, handleSubmit } = formik;

  return (
    <AuthLayout>
      <div className="flex flex-column gap-3">
        <h1>Sign in</h1>

        <FormikProvider value={formik}>
          <div className="flex flex-column gap-5">
            <Input
              icon="pi pi-envelope"
              label="Email"
              id="email"
              placeholder="example@company.com"
              isRequired
            />

            <Password
              lockicon
              id="password"
              label="Password"
              placeholder="Enter Password"
              feedback={false}
            />

            <span className="flex justify-content-end">
              <Link
                to="/forgot-password"
                className="no-underline font-medium text-primary hover:text-primary-700"
              >
                Forgot password?
              </Link>
            </span>

            <Button
              loading={loading}
              label="Sign in"
              className="w-full text-white"
              disabled={!formik.isValid}
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.preventDefault();
                handleSubmit();
              }}
            />
          </div>
        </FormikProvider>
      </div>
    </AuthLayout>
  );
}
